<template>
  <div class="home">
    <pageTop></pageTop>

    <div ref="banner" class="banner content-item-block">
      <div class="video-wrapper">

        <video
            class="video"
            preload="auto"
            muted
            loop
            playsinline
            autoplay
            poster="//juanxiuhe.oss-cn-beijing.aliyuncs.com/web/bannerbg.jpg"
            src="//juanxiuhe.oss-cn-beijing.aliyuncs.com/dibao/home.mp4"
            tabindex="-1"
        ></video>

      </div>
      <h1 class="banner-title">

        专注直播,奔赴热爱
        <div class="subTitle">JOIN EAST·DB</div>
      </h1>
      <div class="search">
        <img @click="searchJobs" src="@/assets/images/06.png" style="width: 160px;">
      </div>
      <div class="arrow-down" @click="scrollDown()"></div>

    </div>
    <div class="staffStory content-item-block">

      <h2 class="title">校园招聘</h2>
    </div>
    <div class="row">
      <div class="col-md-1 h-f">
      </div>



      <div class="col-md-3 h-f"  v-for="item in campusList">
        <figure class="effect-jazz">
          <div class="card__2b15F bg-blue__Se1Tv">
            <div class="layout__fL2iB">
              <div class="text__oBYsw title-main__2y7C2">{{ item.title }}</div>
              <div class="text__oBYsw title-sub__1WQgn">{{ item.content }}</div>
              <div class="text__oBYsw">{{ item.recruitRequire }}</div>
            </div>
            <div class="layout__fL2iB right__GwHP7">
              <a class="text__oBYsw"  href="/jobs" rel="noopener noreferrer">一键投递</a>
            </div>
          </div>
        </figure>
      </div>



      <div class="clearfix"></div>
    </div>


    <div class="staffStory content-item-block">

      <h2 class="title" style="margin-top: 10px">公司不同领域产品</h2>
    </div>

    <div class="row">
      <div class="col-md-1">
      </div>
      <div class="col-md-10 box-shadow">
        <div class="row" style="margin: 50px;">
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/13.png" style="width: 80px;"></a>
          </div>
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/14.png" style="width: 80px;"></a>
          </div>
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/15.png" style="width: 80px;"></a>
          </div>
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/16.png" style="width: 80px;"></a>
          </div>
        </div>
        <div class="row" style="margin: 50px;">
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/17.png" style="width: 80px;"></a>
          </div>
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/18.png" style="width: 80px;"></a>
          </div>
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/19.png" style="width: 80px;"></a>
          </div>
          <div class="col-md-3" style="text-align: center;">
            <a ><img src="@/assets/images/20.png" style="width: 100px;"></a>
          </div>
        </div>
      </div>

      <div class="col-md-1">
      </div>

    </div>

    <!-- 员工故事 -->
    <div class="staffStory content-item-block">
      <h2 class="title"  style="margin-top: 20px">员工故事</h2>
      <ul class="staffStory-list clearfix">
        <router-link
            tag="li"
            :to="`/staff-stories/${item.id}`"
            v-for="item in staffStories"
            :key="item.id"
            class="staffStory-item"
        >
          <div class="avatar">
            <img width="100%" :src="item.avatar" alt srcset/>
          </div>
          <div class="text">
            <h2 class="title">{{ item.title }}</h2>
            <div class="desc">{{ item.name }}&nbsp;|&nbsp;{{ item.department }}</div>
            <p class="remark">{{ item.remark }}</p>
          </div>
          <div class="circular-button">→</div>
        </router-link>
      </ul>
    </div>
    <Footer></Footer>

  </div>
</template>

<script>
// @ is an alias to /src
import {watchScrollDirection} from "@/helper/utilities.js";
import Footer from "@/components/footer.vue";
import pageTop from "@/components/pageTop/pageTop";
import home, {getCampus,getStaffStories} from "@/api/home";

export default {
  name: "home",
  components: {pageTop, Footer},
  data() {
    return {
      productLayerVisible: true,
      search: "",
      products: [],
      campusList: [],
      byteStandards: [],
      byteStandardActiveIndex: 0,
      staffStories: []
    };
  },
  created() {

    // this.request.get("/staff-stories").then(response => {
    //   this.staffStories = response;
    // });
  },

  methods: {
    onScrollRightAnimationEnd() {
      this.productLayerVisible = false;
    },
    scrollDown() {

      window.scrollBy(0, 1000);
      // this.$refs.product.scrollIntoView({
      //   behavior: "smooth",
      //   block: "start"
      // });
    },
    searchJobs(keyword) {
      this.$router.push({name: "jobs", params: {keyword}});
    },
    jumpToDetail(item) {
      this.$router.push({name: "products", params: item});
    }
  },
  mounted() {

    home.getCampus({orderBy:"createTime"}).then(rs => {
      this.campusList = rs.data
    })

    home.getStaffStories({orderBy:"createTime"}).then(rs => {
      this.staffStories = rs.data
    })
  },
  destroyed() {
    this.unwatch();
  }
};
</script>

<style>
/* @import "../assets/transition.css";  */
</style>

<style lang="less" scoped>
.card__2b15F.bg-blue__Se1Tv {
  background-color: #f4bc20;
  background-position: 36px 80px;
  height: 450px;
}

.card__2b15F .text__oBYsw {
  padding: 15px;
  margin-bottom: 65px;
  //font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: white;
}

.card__2b15F .layout__fL2iB.right__GwHP7 a {
  margin-left: 10px;
  padding: 24px 24px;
  border: 2px solid #f5f5f5;
  border-radius: 30px;
  font-size: 20px;
  font-weight: 400;
  line-height: 24px;
}

.card__2b15F .text__oBYsw.title-main__2y7C2 {
  margin-bottom: 65px;
  font-size: 28px;
  font-weight: 700;
  line-height: 34px;
  color: white;
}

a:active,
a:hover {
  text-decoration: none;
  outline: 0;
}

.card__2b15F .text__oBYsw.title-sub__1WQgn {
  margin-bottom: 12px;
  margin-top: 22px;
  font-size: 22px;
  font-weight: 500;
  line-height: 27px;
  color: white;
}

.card__2b15F .layout__fL2iB.right__GwHP7 {
  display: -ms-flexbox;
  display: flex;
  -ms-flex-align: end;
  align-items: end;
  -ms-flex: 1;
  flex: 1 1;
  -ms-flex-pack: start;
  justify-content: flex-start;
  color: white;
}
</style>
